import React from 'react';
import PropTypes from 'prop-types';
import { getData } from '../data';
import { getSharedData } from '../../shared/data';
import Layout from '../../layout/layout';
import ContactSection from '../../shared/components/contact/contact';
import Metatags from '../../shared/components/metatags/metatags';
import HeadingWithMainAndUseCases from '../../shared/components/heading-with-main-and-use-cases/heading-with-main-and-use-cases';
import TransformativeUseCases from '../components/use-cases/transformative-use-cases';
import HeaderWithVideo from '../../shared/components/header-with-video/HeaderWithVideo';

const SolutionsTemplate = props => {
  const { pageContext } = props;
  const { lang } = pageContext;
  const data = getData(lang.key);
  const sharedData = getSharedData(lang.key);

  return (
    <Layout pageContext={pageContext}>
      <Metatags content={sharedData.metatags} lang={lang.key} page='solutions' />
      <HeaderWithVideo content={data.intro} />
      <HeadingWithMainAndUseCases content={data.federated_learning} type='solutions' />
      <TransformativeUseCases content={data.trasformative_use_cases} />
      <ContactSection content={sharedData.contact} />
    </Layout>
  );
};

SolutionsTemplate.displayName = 'SolutionsTemplate';
SolutionsTemplate.propTypes = {
  pageContext: PropTypes.shape({
    lang: PropTypes.shape({
      key: PropTypes.string,
    }),
  }),
};
export default SolutionsTemplate;
